import React, { useEffect } from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import EahsForm from "../../../../components/EahsForm";
import FormCheckbox from "../../../../components/FormInputs/FormCheckbox";
import { useFormContext } from "react-hook-form";
import { eformTerms } from "../../../../common/cssclasses";

const HorseLeasingTermsSection = ({
    termsList,
    isReadOnly
}) => {
    const { translate } = useTranslate();
    const { setValue } = useFormContext();

    useEffect(() => {
        if (isReadOnly && termsList && termsList.length > 0) {
            termsList.forEach((_, index) => {
                setValue(`term_${index}`, true);
            });
        }
    }, [isReadOnly, termsList, setValue]);

    if (!termsList || termsList.length === 0) {
        return null;
    }

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.TERMS, "Terms")}>
            {termsList.map((item, index) => {
                const name = `term_${index}`;
                return (
                    <div className={eformTerms} key={index}>
                        <FormCheckbox 
                            name={name}
                            label={item} 
                            disabled={isReadOnly}
                            required={true}
                        />
                    </div>
                );
            })}
        </EahsForm>
    );
};

export default HorseLeasingTermsSection;
